import React, { useState } from "react";
import { getApiUrl } from "../../config/api";
import { EyeIcon } from "./AdminIcons";

const Login = ({ onLogin, setNotification, onSwitch }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(getApiUrl('LOGIN'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, isAdmin: true }),
      });
      const data = await res.json();
      if (res.ok && data.success && data.user?.isAdmin) {
        setSuccess("Admin login successful!");
        localStorage.setItem("adminToken", data.token);
        onLogin(data.user);
      } else {
        setError(data.message || "Admin login failed");
      }
    } catch (err) {
      console.error("Admin Login API Error:", err);
      setError("Network error. Could not connect to the server.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="text-center mb-0 w-full flex justify-center">
        <div className="flex items-center justify-start w-full max-w-md">
          <img src="/logo1.png" alt="Logo" className="w-24 h-16 sm:w-40 sm:h-24 object-contain" />
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-yellow-600 leading-tight mb-0">AHMEDABAD POST</h1>
            <p className="text-gray-600 text-sm sm:text-base leading-tight mb-0">Admin Panel</p>
          </div>
        </div>
      </div>
      <div className="max-w-md w-full bg-white p-6 sm:p-8 rounded-lg shadow-lg mt-0">
        <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-6">Administrator Login</h2>
        <form onSubmit={handleAdminLogin}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">Email</label>
            <input id="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="e.g., master@amdavadpost.com" required />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">Password</label>
            <div className="relative">
              <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} className="shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="******************" required />
              <button type="button" onClick={() => setShowPassword((s) => !s)} className="absolute right-2 top-2 text-gray-500 hover:text-gray-800" aria-label={showPassword ? 'Hide password' : 'Show password'} tabIndex={-1}>
                <EyeIcon open={showPassword} />
              </button>
            </div>
          </div>
          {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
          {success && <div className="text-green-600 text-sm mb-4">{success}</div>}
          <div className="flex items-center justify-center">
            <button type="submit" className="w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transition-colors duration-300" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </div>
        </form>
        <div className="mt-4 text-center">
          <span className="text-gray-600 text-sm">Not a user? </span>
          <button type="button" className="text-blue-600 hover:underline font-semibold text-sm" onClick={onSwitch}>Sign Up</button>
        </div>
      </div>
    </div>
  );
};

export default Login;
